import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { DeviceIdService } from '../device-id.service';

/**
 * Sends the trusted-device id on every API request.
 *
 * The gateway re-checks device trust on each call, not only at login: without the
 * header an authenticated user gets a 403 with `X-2FA-Required: true` while browsing,
 * even though the login succeeded.
 *
 * It has to live in its own interceptor because `AuthInterceptorService` short-circuits
 * requests marked with `noCheckToken` (ext-login, auto-login, refresh) before reaching
 * its header logic — and those are precisely the calls that need the device id.
 */
@Injectable()
export class DeviceIdInterceptor implements HttpInterceptor {
  constructor(private deviceIdService: DeviceIdService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    const deviceId = this.deviceIdService.get();
    if (!deviceId) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: { [DeviceIdService.HEADER]: deviceId },
      }),
    );
  }
}
